import {Button} from '@ui/buttons/button';
import {Link} from 'react-router';
import type {BlockInstance} from '../appearance-data';
import {EyebrowPill} from './eyebrow-pill';

/** Call-to-action banner. */
export function CtaBlock({props}: {block: BlockInstance; props: Record<string, any>}) {
  return (
    <section className="px-24 py-56" style={{backgroundColor: props.bg_color || '#111827', color: props.text_color || '#fff'}}>
      <div className="mx-auto flex max-w-[960px] flex-col items-center gap-16 text-center">
        <EyebrowPill text={props.eyebrow} />
        {props.heading ? <h2 className="text-2xl font-bold md:text-3xl">{props.heading}</h2> : null}
        {props.text ? <p className="max-w-720 opacity-90">{props.text}</p> : null}
        {props.button_label ? (
          <Button variant="flat" color="primary" size="lg" className="mt-8 rounded-full"
            elementType={Link} to={props.button_url || '/'}>
            {props.button_label}
          </Button>
        ) : null}
      </div>
    </section>
  );
}
